/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { forwardRef } from 'react';
import { Notifications as Nav4Notifications } from '@atlaskit/navigation-system/top-nav-items/notifications';
import { expVal } from '@atlassian/jira-feature-experiments';
import type { ExperimentalNotificationProps } from '../../types.tsx';

export const Notification: React.ForwardRefExoticComponent<
	ExperimentalNotificationProps & React.RefAttributes<HTMLElement>
> = forwardRef<HTMLElement, ExperimentalNotificationProps>((props, ref) => {
	const { badge, onClick, isSelected, label } = props;

	return (
		<Nav4Notifications
			isListItem={false}
			badge={badge}
			label={label}
			onClick={onClick}
			isSelected={isSelected}
			// oxlint-disable-next-line typescript/consistent-type-assertions -- PLEASE FIX - ENABLING FLAT LINT CONFIG
			ref={ref as React.ForwardedRef<HTMLButtonElement>}
			{...(expVal('jracloud-98425-notification-btn-expand-state', 'isEnabled', false)
				? { 'aria-haspopup': 'dialog', 'aria-expanded': isSelected }
				: {})}
		/>
	);
});
